module.exports = __webpack_public_path__ + "05_short_brown.e7b4158c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/05_short_brown.png
// module id = e2MG
// module chunks = 0